module.exports = __webpack_public_path__ + "static/media/Experience2021.ecc975fe.png";